module.exports = __webpack_public_path__ + "img/3A3D37_7E7F75_BCBFB6_9C9C94-256px.4a304ac2.png";